<template>
  <div>
    <div>
      <div class="bordered-tabs d-flex justify-content-between">
        <strong class="h5 font-weight-black">
          {{ locale.list }} {{ locale.branches.tabTitle }}
        </strong>
        <div>
          <naj-button
            :disabled="isViewMode || (auditConfirmations[`flag_${mainRequestAuditFlag.branchesConfirmation}`] && isNotCompleted)"
            color="primary"
            @click="addNewHandler"
          >
            <v-icon
              left
              v-text="`mdi-plus`"
            ></v-icon>
            {{ local.common.add }}
          </naj-button>
          <!-- <naj-button
          color="primary"
          @click="importDataHandler"
        >
          {{ locale.importData }}
        </naj-button> -->
        </div>
      </div>
      <div>
        <slot />
      </div>
      <div>
        <v-row>
          <v-col>
            <naj-item-table
              :data-items="branch.list"
              :headers="headers"
              :loading="loading"
              :pagination="pagination"
              :items-per-page="pagination.pageSize"
              :server-items-length="pagination.totalCount"
              :enable-expand="false"
              @update:page="onPageChange"
            >
              <template
                slot="actionEdit"
                slot-scope="{item}"
              >
                <naj-button
                  :disabled="isViewMode || (auditConfirmations[`flag_${mainRequestAuditFlag.branchesConfirmation}`] && isNotCompleted)"
                  outlined
                  @click="showUpdateModal(item)"
                >
                  {{ local.common.update }}
                </naj-button>
              </template>
              <template
                slot="actionDelete"
                slot-scope="{item}"
              >
                <naj-button
                  :disabled="isViewMode || (auditConfirmations[`flag_${mainRequestAuditFlag.partnersConfirmation}`] && isNotCompleted)"
                  type="button"
                  color="error"
                  outlined
                  @click="showPopupRemove(item)"
                >
                  {{
                    local.common.remove
                  }}
                </naj-button>
              </template>
            </naj-item-table>
          </v-col>
        </v-row>
      </div>
    </div>
    <naj-modal
      ref="branchModal"
      :title="`${isEditMode? local.common.update:local.common.add} ${locale.branches.branch}`"
      :width="1200"
      show-footer-close-button
      @onClose="onCloseModal"
    >
      <v-form ref="addForm">
        <branch-form
          :form-model="formModel"
          :loading="loading"
        ></branch-form>
      </v-form>
      <template slot="actions">
        <naj-button
          :loading="loading"
          @click="submit"
        >
          {{ isEditMode? local.common.update :local.common.add }}
        </naj-button>
      </template>
    </naj-modal>
    <naj-confirmation
      :show-modal="showRemovePopup"
      color="error"
      :title="local.common.removeConfirmation"
      :message="local.common.removeConfirmationMessage"
      :ok-btn-label="local.common.remove"
      @ok="removeBranch"
      @cancel="showRemovePopup = false"
    ></naj-confirmation>
  </div>
</template>

<script>
import BranchForm from './branch-form.vue';
import { createNamespacedHelpers } from 'vuex';
const { mapActions, mapGetters, mapState } = createNamespacedHelpers('BankruptcyModule');
import { partyTypeEnum, mainRequestAuditFlag, requestStatusEnum } from '@/modules/bankruptcy/helpers/enum';

export default {
  components: { BranchForm },
  props: {
    requestObjectKey: {
      type: String,
      required: true,
      default: '',
    },
  },
  data() {
    return {
      partyTypeEnum,
      locale: this.local.bankruptcy.requestDetails,
      branch: { list: [] },
      headers: [
        {
          value: 'index',
          text: this.local.bankruptcy.requestDetails.sequence,
        },
        {
          value: 'name',
          text: this.local.bankruptcy.requestDetails.branches.theBranch,
        },
        {
          value: 'commercialRegistrationNumber',
          text: this.local.bankruptcy.requestDetails.branches.commercialRegisterNo,
        },
        {
          value: 'actionEdit',
          class: 'action-item justify-content-center',
          isCustomTemplate: true,
        },
        {
          value: 'actionDelete',
          class: 'action-item justify-content-center',
          isCustomTemplate: true,
        },

      ],
      pagination: {
        pageSize: 10,
        pageIndex: 0,
        totalCount: 0,
        totalPages: 0,
        hasPreviousPage: false,
        hasNextPage: false,
      },
      formModel: {},
      loading: false,
      isEditMode: false,
      mainRequestAuditFlag,
      requestStatusEnum,
      showRemovePopup: false,
      selectedItem: {},
    };
  },
  computed: {
    ...mapGetters([
      'isViewMode',
      'isNewMode',
      'isNotCompleted',
    ]),
    ...mapState({ auditConfirmations: state => state.auditConfirmations }),
  },
  mounted() {
    this.pagination.pageIndex = 0;
    this.loadData();
  },
  methods: {
    ...mapActions(['submitAddNewBranch', 'getBranchesByRequestObjectKey', 'getBranch', 'updateBranch', 'deleteBranch']),
    addNewHandler() {
      this.$refs.branchModal.show();
    },
    importDataHandler() { },
    loadData() {
      this.loading = true;
      this.getBranchesByRequestObjectKey({
        requestObjectKey: this.requestObjectKey,
        ...this.pagination,
      })
        .then(({ data }) => {
          this.branch = { ...data };
          this.branch.list.forEach((element, index) => {
            element.index = index + 1 + (this.pagination.pageSize * this.pagination.pageIndex);
          });
          this.pagination = {
            pageIndex: data.pageIndex,
            pageSize: data.pageSize,
            totalCount: data.totalCount,
            totalPages: data.totalPages,
            hasPreviousPage: data.hasPreviousPage,
            hasNextPage: data.hasNextPage,
          };
        })
        .finally(() => {
          this.loading = false;
        });

    },
    onPageChange(pageIndex) {
      this.pagination.pageIndex = pageIndex - 1;
      this.loadData();
    },
    showUpdateModal(model) {
      const params = {
        requestObjectKey: this.requestObjectKey,
        objectKey: model.objectKey,
      };
      this.loading = true;
      this.getBranch(params)
        .then((res) => {
          this.formModel = res.data;
          this.isEditMode = true;
          this.$refs.branchModal.show();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    showPopupRemove(item) {
      this.showRemovePopup = true;
      this.selectedItem = item;
    },
    removeBranch() {
      const params = {
        requestObjectKey: this.requestObjectKey,
        objectKey: this.selectedItem.objectKey,
      };
      this.loading = true;
      this.deleteBranch(params)
        .then(() => {
          this.loadData();
          this.toaster.success(this.local.bankruptcy.common.removeSuccessfully);
        })
        .finally(() => {
          this.loading = false;
          this.showRemovePopup = false;
        });
    },
    submit() {
      if (this.$refs.addForm)
        this.$refs.addForm.$validator.validateAll().then((valid) => {
          if (valid) {
            this.loading = true;
            this.formModel.requestObjectKey = this.requestObjectKey;
            const method = this.formModel.objectKey ? 'updateBranch' : 'submitAddNewBranch';
            this[method]({
              requestObjectKey: this.requestObjectKey,
              ...this.formModel,
            })
              .then(() => {
                const message = this.formModel.objectKey ? 'updateSuccessfully' : 'addedSuccessfully';
                this.$refs.branchModal.close();
                this.loadData();
                this.toaster.success(this.local.bankruptcy.common[message]);
              })
              .finally(() => { this.loading = false; });
          }
        });
    },
    resetForm() {
      this.$refs.addForm.$validator.reset();
    },
    onCloseModal() {
      for (const key in this.formModel)
        if (Object.hasOwnProperty.call(this.formModel, key))
          this.$set(this.formModel, key, undefined);
      this.isEditMode = false;
      this.resetForm();
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .info-item-box .info-item-details:nth-child(1) {
  background: var(--app-light-secondary-color) 0% 0% no-repeat padding-box;
}
</style>